import React from "react";

import ServingInfo from "./read-only/serving-info";
import CalorieInfo from "./read-only/calorie-info";
import FactItemList from "./read-only/fact-item-list";
import Footnotes from "./read-only/footnotes";

import { readOnlyValue } from "components/attributes/lib/attribute-data";

const PanelReadOnly = (props) => {
    const columnCount = props.panel.columns.length;

    const servingInfoData = props.panel.columns.map((c) => {
        return {
            header: c.header,
            servingSize: c.servingSize,
            servingSizeMetric: c.servingSizeMetric,
            servingSizeVisual: c.servingSizeVisual,
            servingsPerContainer: c.servingsPerContainer,
            servingAccuracy: c.servingAccuracy,
            servingSizeDescription: c.servingSizeDescription,
        };
    });

    const calorieInfoData = props.panel.columns.reduce((col, c) => {
        col.push(c.calorie);

        return col;
    }, []);

    const dietaryInfoData = props.panel.columns.reduce((col, c) => {
        col.push({ facts: c.dietary.facts });

        return col;
    }, []);

    const vitamineralData = props.panel.columns.reduce((col, c) => {
        col.push({ facts: c.vitamineral.facts });

        return col;
    }, []);

    return (
        <div className="nutrition-panel panel -read-only">
            <div className="header-info">{props.panel.header}</div>

            <ServingInfo
                data={servingInfoData}
                panel={props.selectedIndex}
                updateField={props.updateField}
            />

            <CalorieInfo
                data={calorieInfoData}
                panel={props.selectedIndex}
                updateField={props.updateField}
                section="calorie"
            />

            <FactItemList
                data={dietaryInfoData}
                panel={props.selectedIndex}
                columnCount={columnCount}
                addFact={props.addFact}
                updateFacts={props.updateFacts}
                section="dietary"
                isCodingQA={props.isCodingQA}
            />

            <FactItemList
                data={vitamineralData}
                panel={props.selectedIndex}
                columnCount={columnCount}
                addFact={props.addFact}
                updateFacts={props.updateFacts}
                showDescription={props.showDescription}
                section="vitamineral"
                isCodingQA={props.isCodingQA}
            />

            <Footnotes
                data={props.panel.footnotes}
                isCodingQA={props.isCodingQA}
            />

            <div className="ingredients">
                <h4 className="-tighten-margin">Ingredients:</h4>
                {props.panel.ingredients.leadIn}
                <br />
                {readOnlyValue(props.panel.ingredients.items, "MultiDropdownPicklist")}
            </div>
        </div>
    );
};

export default PanelReadOnly;
